import { Component, OnInit, OnDestroy } from '@angular/core';
import { BrokerTransactionApprovalService } from '../broker-transaction-approval.service';
import { Subscription } from 'rxjs';
import { ApproveActionTypeModel } from '../../../model/approveActionTypeModel';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SubmitTransactionApprovalRequestModel } from '../../../model/submitTransactionApprovalRequestModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import * as $ from 'jquery';
import { SubmitTransactionApprovalResponseModel } from '../../../model/submitTransactionApprovalResponseModel';
import { Router } from '@angular/router';
import { StorageService } from '../../../shared/security/StorageService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IndividualLicenseComponent } from '../individual-license/individual-license.component';

@Component({
  selector: 'app-broker-transaction-approval',
  templateUrl: './broker-transaction-approval.component.html',
  styleUrls: ['./broker-transaction-approval.component.css']
})
export class BrokerTransactionApprovalComponent implements OnInit, OnDestroy {


  title: string = "";
  notifyPendingTransactionsListSubscription: Subscription = new Subscription();
  startFunctionBrokerRespSubscription: Subscription = new Subscription();

  pendingApprovalsList: Array<ApproveActionTypeModel> = [];
  pendingApprovalsToConfirm: Array<ApproveActionTypeModel> = [];
  none: boolean = false;

  startFunction: StartFunctionResponseModel = {};

  submitTransactionApprovalRequestModel: SubmitTransactionApprovalRequestModel = new SubmitTransactionApprovalRequestModel();

  constructor(private brokerTranApprovalService: BrokerTransactionApprovalService,
    private currentPageWatcherService: CurrentPageWatcherService,
    private startFunctionService: StartFunctionService,
    private router: Router,
    private storageService: StorageService,
    private modalService: NgbModal) {


    this.startFunction = this.storageService.getStartFunctionData();

    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      // this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
     
      this.title=this.startFunction.Workflow.WorkflowDisplayName;
      this.submitTransactionApprovalRequestModel.workflowID = this.startFunction.Workflow.WorkflowID;
      this.submitTransactionApprovalRequestModel.CurrentStepIndex = this.startFunction.Workflow.CurrentStepIndex;
      this.brokerTranApprovalService.getPendingTransactions(this.startFunction.FunctionID).subscribe(
        response => {
          let pendingApprovals = response;
          pendingApprovals.forEach((element: ApproveActionTypeModel) => {

            element.approve = -1;
            this.pendingApprovalsList.push(element);

          });
          console.log("pendingApprovals from BrokerTransactionApprovalComponent => ", pendingApprovals);
        }
      )
    }

  }

  ngOnInit() {
    this.currentPageWatcherService.pageChanged().emit(this.title);
  }

  onFirstSubmit() {
    this.pendingApprovalsList.forEach(el => {
      if (el.approve == 0) {
        this.submitTransactionApprovalRequestModel.DisapprovedQueueID.push(el.QueueID);
        el.licenseAction = "Disapproved";
      }
      if (el.approve == 1) {
        this.submitTransactionApprovalRequestModel.ApprovedQueueID.push(el.QueueID);
        el.licenseAction = "Approved";
      }

      if (el.approve != -1) {
        this.pendingApprovalsToConfirm.push(el);
      }

    });

    console.log("submit transaction approval ", this.submitTransactionApprovalRequestModel);

    if (this.submitTransactionApprovalRequestModel.DisapprovedQueueID.length == 0 && this.submitTransactionApprovalRequestModel.ApprovedQueueID.length == 0) {
      this.none = true;
      $("html, body").animate({ scrollTop: 0 }, "slow");
    }
    else {
      this.router.navigate(["/submitPendingApprovals"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(true);
        this.brokerTranApprovalService.getNotifySubmitTransactionApprovalResponseModel().emit(this.submitTransactionApprovalRequestModel);
        this.brokerTranApprovalService.getNotifyPendingTransactionsList().emit(this.pendingApprovalsToConfirm);
      })


    }
  }

  open(indivID: number){
    const modalRef = this.modalService.open(IndividualLicenseComponent);
    modalRef.componentInstance.indivID = indivID;
  }

  goBackHome(){
    this.router.navigate(["/home"]);
  }

  ngOnDestroy(): void {
    this.notifyPendingTransactionsListSubscription.unsubscribe();
    this.startFunctionBrokerRespSubscription.unsubscribe();
    this.currentPageWatcherService.clearUserMessage();
    this.currentPageWatcherService.clearStepMessage();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/view-pending-approvals/broker-transaction-approval/broker-transaction-approval.component.ts